import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { routes } from './app.routes';
import { MatChipsModule } from '@angular/material/chips';
import { provideMsal } from './msal.config';
import { MarkdownModule } from 'ngx-markdown';
import { TimeagoModule } from 'ngx-timeago';
import { LinkedFieldsService } from './Services/linkedFields.service';
import { FormFlowService } from './Services/formFlow.service';
import { ParamMapService } from '@app/Tenant/Applications/Airsweb/Services';
import { SubmissionTypeConfigService } from './Tenant/Applications/Airsweb/Module/step/submission-type-config/submission-type-config.service';
import { FeedService } from '@app/Tenant/Applications/Airsweb/Services';
import { FeedHistoryService } from './Tenant/Applications/Airsweb/Services/feed-history.service';
import { FreeTrialService } from './Tenant/Applications/FreeTrialAdministration/services/free-trial.service';
import { TenantConfigurationService } from './Tenant/Applications/Airsweb/Services/tenant-configuration.service';
import { TenantValidator, ImportIdValidator } from './Tenant/Validators';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideMsal('/api/authconfig'),
    importProvidersFrom(
      FormsModule,
      MatChipsModule,
      MarkdownModule.forRoot(),
      TimeagoModule.forRoot()
    ),
    LinkedFieldsService,
    FormFlowService,
    ParamMapService,
    SubmissionTypeConfigService,
    FeedService,
    FeedHistoryService,
    FreeTrialService,
    TenantConfigurationService,
    TenantValidator,
    ImportIdValidator,
  ]
};
